import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'dojo-question-validation-header',
  templateUrl: './question-validation-header.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrls: ['./question-validation-header.component.scss'],
  standalone: true,
})
export class QuestionValidationHeaderComponent {}
